import { render, staticRenderFns } from "./miniGameTemplate.vue?vue&type=template&id=c5f31e0c&lang=pug"
import script from "./miniGameTemplate.vue?vue&type=script&lang=js"
export * from "./miniGameTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports